module.exports = __webpack_public_path__ + "static/img/thzx-flash.2bbd8d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thzx-flash.png
// module id = 7tkj
// module chunks = 0